export default __webpack_public_path__ + "24ff062bc2308038c850c951dcfda825.glb";